module.exports = __webpack_public_path__ + "img/orbit-3.dee60f97.svg";